import { useState, useEffect, useContext } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import * as utilConstants from "../../../../../utils/constants/utilsConstants";
import DeleteModal from "../../../../common/commonModal/DeleteModal";
import ReactNotifications from "../../../../common/reactNotifications/ReactNotifications";
import { acceptSheetInvitation } from "../../../../../api/businessAndEnterprise/sheetApi";
import Context from "../../../../../context/Context";

const SheetInvitation = () => {
    const [show, setShow] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const { user } = useContext(Context);

    const handleAccept = () => {
        if (token) {
            acceptSheetInvitation(token, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    setShow(false);
                    if (['Company Head', 'Team Head', 'Member'].includes(user?.role)) return navigate('/personal/drive');
                    if (user?.role === 'Personal User') return navigate('/dashboard/personal');
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleIgnore = () => {
        setShow(false);
        setShouldRedirect(true);
    };

    useEffect(() => {
        if (!token) {
            setShouldRedirect(true);
        } else {
            setShow(true);
        }
    }, [token]);

    if (shouldRedirect) {
        if (['Company Head', 'Team Head', 'Member'].includes(user?.role)) return <Navigate to="/dashboard" replace />;
        if (user?.role === 'Personal User') return <Navigate to="/dashboard/personal" replace />;
        return <Navigate to="/dashboard" replace />;
    }

    const modalMessage = "You have been invited to join a sheet. Do you want to accept this sheet invitation?";

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
            <DeleteModal
                show={show}
                onClose={handleIgnore}
                onConfirm={handleAccept}
                confirmText="Accept"
                cancelText="Ignore"
                cancelButtonStyle="!bg-white text-black border border-gray-300 hover:!bg-gray-100 py-2 px-6 font-semibold transition-colors"
                confirmButtonStyle="!bg-[#AEF468] !border-none text-black hover:!bg-[#9DE357] py-2 px-6 font-semibold transition-colors"
                title="Accept Sheet Invitation"
                message={modalMessage}
            />
        </div>
    );
};

export default SheetInvitation;